"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ready = exports.findOne = exports.find = void 0;
/**
 * Find some elements.
 * Use;
 * ```
 * find<HTMLElement>('.some-class');
 * ```
 * @param selector
 * @param element
 */
function find(selector, element = document.documentElement) {
    return Array.from([...Element.prototype.querySelectorAll.call(element, selector)]);
}
exports.find = find;
/**
 * Find one element.
 * Use:
 * ```
 * findOne<HTMLElement>('#id');
 * ```
 * @param selector
 * @param element
 */
function findOne(selector, element = document.documentElement) {
    return Element.prototype.querySelector.call(element, selector);
}
exports.findOne = findOne;
/**
 * A jQuery-like ready function.
 * Use:
 * ```
 * ready(() => {});
 * ```
 * @param callbackFunc
 */
function ready(callbackFunc) {
    if (document.readyState !== 'loading') {
        callbackFunc();
    }
    else if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', (e) => callbackFunc(e));
    }
}
exports.ready = ready;
